'use strict';
angular.module('weixinSignedModule', ['weixinSignedRouterModule']).controller('weixinSignedCtrl', [
    '$scope',
    'storageListenerService',
    'editIsLock',
    '$state',
    'trsHttpService',
    'modalDialog',
    'trsspliceString',
    '$q',
    'wechatBtnService',
    '$window',
    'editingCenterService',
    'trsPrintService',
    'editcenterRightsService',
    '$filter',
    'newMediaService',
    'weixinConst',
    function (
        $scope,
        storageListenerService,
        editIsLock,
        $state,
        trsHttpService,
        modalDialog,
        trsspliceString,
        $q,
        wechatBtnService,
        $window,
        editingCenterService,
        trsPrintService,
        editcenterRightsService,
        $filter,
        newMediaService,
        weixinConst,
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.data = {
                items: [],
                selectedArray: [],
                printResult: [],
                trench: weixinConst.listenStroageKey,
            };
            $scope.status = {
                copyCurrPage: 1,
                isOnlyMine: false,
                isSearch: false,
                theChannelType: '', // 公众号类型
                theChannelTypeText: '',
                mouseenter: false,
                channelId: $state.params.wxchannelid,
                isSendStatus: {
                    // '0': '已签发',
                    // '1': '群发中',
                    // '2': '已群发',
                    // '3': '群发失败',
                    // '4': '签发中',
                    // '5': '签发失败',
                    '0': '已签发',
                    '1': '群发中',
                    '2': '已群发',
                    '3': '群发失败',
                    '4': '签发中',
                    '5': '签发失败',
                    '6':'定时签发'
                },
            };
        }

        /**
         * [showVersionTime description]展示流程版本与操作日志
         * @param  {[str]} item [description]
         * @return {[type]}            [description]
         */
        $scope.showVersionTime = function (item) {
            editingCenterService.getVersionTime(item, false);
        };

        /**
         * [initBtnRights description] 初始化权限
         * @return {[type]} [description]
         */
        function initBtnRights() {
            editcenterRightsService.initWeixinListBtn('wechat.yiqianfa', $scope.status.channelId).then(function (rights) {
                $scope.status.btnRights = rights;
            });
        }

        /**
         * [collect description] 稿件收藏
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.collect = function () {
            $scope.status.isSearch = false;
            modalDialog.confirmModal('稿件收藏', '确认收藏稿件', function () {
                var chnlDocIds;
                chnlDocIds = trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ',');
                collectDraft(chnlDocIds);
            });
        };

        /**
         * [collectDraft description] 稿件收藏 参数配置
         * @param  {[type]} array [description]
         * @return {[type]}       [description]
         */
        function collectDraft(array) {
            var params = {
                serviceid: 'mlf_wechatoper',
                methodname: 'collectionYIQIANFADocs',
                ChannelId: $scope.data.selectedArray[0].CHANNELID,
                ChnlDocIds: array,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function () {
                modalDialog.alertType('收藏成功', '', 'success', false, function () {
                    requestData();
                });
            });
        }

        /**
         * [requestListImg description] 查询列表图示 
         * @param   {[type]}  items  [items description]
         * @return  {[type]}         [return description]
         */
        function requestListImg(items) {
            var defer = $q.defer();
            if (!items || items.length < 1) {
                defer.resolve([]);
            } else {
                var params = {
                    serviceid: 'mlf_wechatgroupsend',
                    methodname: 'queryContentPics',
                    DocIds: trsspliceString.spliceString(items, 'METADATAID', ','),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    defer.resolve(data);
                });
            }
            return defer.promise;
        }

        /**
         * [exportDraft description]导出稿件
         * @return {[type]} [description]
         */
        $scope.exportDraft = function () {
            $scope.status.isSearch = false;
            var params = {
                serviceid: 'mlf_exportword',
                methodname: 'exportWordFile',
                MetaDataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                function (data) {
                    $window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                    requestData();
                },
                function (data) {
                    if (data.REPORTS[0].ISSUCCESS == 'true') {
                        $window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                    }
                },
            );
        };

        /**
         * [revoke description] 微信预览
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.wxPreview = function () {
            wechatBtnService.foregoingPreview($scope.data.selectedArray, 'preview', '').then(() => {
                requestData();
            });
        };

        /**
         /**
         * [revoke description] 取消签发
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.revoke = function () {
            var hasSend;
            for (var i in $scope.data.selectedArray) {
                if ($scope.data.selectedArray[i].massSendFalg == '1' || $scope.data.selectedArray[i].massSendFalg == '2') {
                    hasSend = true;
                    break;
                } else {
                    hasSend = false;
                }
            }
            if (!hasSend) {
                $scope.loadingPromise = newMediaService.retraction($scope, weixinConst.withdrawrejection);
            } else {
                modalDialog.alertType('选项中包含已群发稿件，请重新选择', '', 'warning', 'confirm', function () {
                    requestData();
                    return;
                });
            }
        };

        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            // requestData();  由记忆功能调用 $scope.requestData(),此处不再调用
            getChannelType();
            initBtnRights();
            listenStorage();
        }

        /**
         * [toWeixinPreview description] 微信详情页
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.toWeixinPreview = function (item) {
            var url = $state.href(
                'weixinPreview',
                {
                    wxmetadataid: item.METADATAID,
                    wxchannelid: item.CHANNELID,
                    wxchnldocid: item.CHNLDOCID,
                    isSendState: item.massSendFalg != '0',
                },
                { reload: true },
            );
            window.open(url, '_blank');
        };

        /**
         * [isOnlyMine description]只看我的
         * @return {Boolean} [description]
         */
        $scope.isOnlyMine = function () {
            $scope.status.isOnlyMine = !$scope.status.isOnlyMine;
            requestData();
        };

        /**
         * [selectAll description]全选
         * @return {[type]} [description]
         */
        $scope.selectAll = function () {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [outSending description] 邮件外发
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.outSending = function () {
            $scope.status.isSearch = false;
            editingCenterService.outSending('', function (result) {
                outSendingDraft(result.selectItems);
            });
        };

        /**
         * [outsendingDrafe description] 邮件外发 参数配置
         * @param  {[type]} items [description]
         * @param  {[type]} item  [description]
         * @return {[type]}       [description]
         */
        function outSendingDraft(items) {
            var userids = trsspliceString.spliceString(items, 'EMAIL', ',');
            var draftids = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
            var params = {
                serviceid: 'mlf_mailoutgoingOper',
                methodname: 'wechatYiQianFaSendEmail',
                Emails: userids,
                MetaDataIds: draftids,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                modalDialog.alertType('邮件外发成功', '', 'success', false, function () {
                    requestData();
                });
            });
        }

        /**
         * [selectDoc description] 单选
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.selectDoc = function (item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };

        /**
         * [printBtn description] 稿件打印
         * @return {[type]} [description]
         */
        $scope.printBtn = function () {
            $scope.status.isSearch = false;
            angular.forEach($scope.data.selectedArray, function (value, key) {
                requestPrintData(value);
            });
        };

        /**
         * [requestPrintData description] 稿件打印 请求详情
         * @param  {[type]} item    [description]
         * @param  {[type]} version [description]
         * @return {[type]}         [description]
         */
        function requestPrintData(item, version) {
            var params = {
                serviceid: 'mlf_wechat',
                methodname: 'getNewsDoc',
                MetaDataId: item.METADATAID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                var result = data;
                data.VERSION = version;
                data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                $scope.data.printResult.push(result);
                if ($scope.data.printResult.length == $scope.data.selectedArray.length) {
                    trsPrintService.trsWeixinPrintDocument($scope.data.printResult);
                    $scope.data.printResult = [];
                }
            });
        }

        /**
         * [selectPageNum description]选择分页条数
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function () {
            $scope.status.copyCurrPage = 1;
            requestData();
        };

        /**
         * [pageChanged description]跳转到下一页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function () {
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [jumpToPage description]跳转到指定页
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function () {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };

        /**
         * [fullTextSearch description] 点击搜索,回车的时候也发送请求
         * @param   {[type]}  $event  [$event description]
         * @return  {[type]}          [return description]
         */
        $scope.fullTextSearch = function ($event) {
            if ($event !== undefined && $event.keyCode !== 13) {
                return;
            }
            $scope.status.isSearch = true;
            requestData();
        };

        /**
         * [commonReqeust description]普通列表刷新
         * @return {[type]} [description]
         */
        function commonReqeust() {
            var params = {
                serviceid: 'mlf_wechat',
                methodname: 'querySignedDoc',
                ChannelId: $state.params.wxchannelid,
                isOnlyMine: $scope.status.isOnlyMine,
                // timeType: 0,
                OperTimeStart: $scope.status.fromdate,
                OperTimeEnd: $scope.status.untildate,
                CurrPage: $scope.page.CURRPAGE,
                PageSize: $scope.page.PAGESIZE,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                var ListItems = data.DATA;
                $scope.data.items = ListItems;
                $scope.page = data.PAGER;
                $scope.data.selectedArray = [];
                getMassSendFalgs(ListItems);
                requestListImg(ListItems).then(function (data) {
                    angular.forEach(ListItems, function (value, key) {
                        value.ALLIMG = data[value.METADATAID];
                    });
                });
                storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,CHNLDOCID', 'weixinPreview');
            });
        }

        /** 
         * [getMassSendFalgs description] 获取是否群发
         * @param   {[type]}  ListItems  [ListItems description]
         * @return  {[type]}             [return description]
         */
        function getMassSendFalgs(ListItems) {
            var defer = $q.defer();
            var docIds = trsspliceString.spliceString(ListItems, 'METADATAID', ',');
            var params = {
                serviceid: 'mlf_wechatgroupsend',
                methodname: 'isDocGroupSend',
                DocIds: docIds,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                angular.forEach(ListItems, function (value, key) {
                    jQuery.each(data, function (i, val) {
                        if (value.METADATAID == i) {
                            ListItems[key].massSendFalg = val;
                        }
                    });
                });
                defer.resolve(ListItems);
            });
            return defer.promise;
        }

        /**
         * [searchRequest description]搜索状态下列表刷新
         * @return {[type]} [description]
         */
        function searchRequest() {
            var params = {
                serviceid: 'mlf_hybasesearch',
                methodname: 'queryForWeChatSignedDoc',
                searchParams: JSON.stringify({
                    PAGESIZE: $scope.page.PAGESIZE,
                    PAGEINDEX: $scope.page.CURRPAGE,
                    searchFields: [
                        {
                            searchField: '',
                            keywords: $scope.keywords ? $scope.keywords : '',
                        }, // 搜索词
                        {
                            searchField: 'timeType',
                            keywords: !$scope.status.untildate ? '' : $scope.status.fromdate + ',' + $scope.status.untildate,
                        }, // 时间,如果没有选择时间传空
                        {
                            searchField: 'isOnlyMine',
                            keywords: $scope.status.isOnlyMine,
                        }, // 是否只看我的
                        {
                            searchField: 'channelid',
                            keywords: $state.params.wxchannelid,
                        },
                        {
                            searchField: '_sort',
                            keywords: 'time',
                        }, // 后端规定的参数
                    ],
                }),
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                var ListItems = data.DATA;
                $scope.data.items = ListItems;
                $scope.data.selectedArray = [];
                $scope.page = data.PAGER;
                getMassSendFalgs(ListItems);
                requestListImg(ListItems).then(function (data) {
                    angular.forEach(ListItems, function (value, key) {
                        value.ALLIMG = data[value.METADATAID];
                    });
                });
                storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,CHNLDOCID', 'weixinPreview');
            });
        }

        /**
         * [requestData description]获取列表数据
         * @return {[type]} [description]
         */
        function requestData() {
            if (!$scope.status.isSearch) {
                commonReqeust();
            } else {
                searchRequest();
            }
        }

        /**
         * [requestData description]刷新列表
         * @return {[type]} [description]
         */
        $scope.requestData = function () {
            requestData();
        };

        /**
         * [isLockEdit description] 编辑前请求解锁
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.isLockEdit = function (item) {
            if (!(item.massSendFalg == '0')) {
                modalDialog.alertType(
                    $scope.status.isSendStatus[item.massSendFalg] + '的稿件不能再进行编辑',
                    '',
                    'warning',
                    'confirm',
                    function () {
                    },
                );
                return;
            } else {
                $scope.status.isSearch = false;
                editIsLock.isLock(item, 4).then(function (data) {
                    var editPath = 'wxeditpage';
                    var editParams = {
                        wxchannelid: $scope.status.channelId,
                        wxchnldocid: item.CHNLDOCID,
                        wxmetadataid: item.METADATAID,
                        wxplatform: 2,
                    };
                    var editUrl = $state.href(editPath, editParams);
                    if (data.ISLOCK == 'false') {
                        window.open(editUrl);
                    } else {
                        editIsLock.checkUnlockPermissions(item, data).then(function () {
                            window.open(editUrl);
                        });
                    }
                });
            }
        };

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenWeixin(function () {
                $scope.status.isSerach = false;
                requestData();
                storageListenerService.removeListener('website');
            }, $scope);
        }

        /**
         * [getChannelType description] 查询公众号类型
         * @return {[type]} [description]
         */
        function getChannelType() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_wechatgroupsend',
                methodname: 'getChannelType',
                ChannelIds: $state.params.wxchannelid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                $scope.status.theChannelType = data[$state.params.wxchannelid];
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [groupSendMessage description] 群发消息按钮hover提示
         * @return {[type]} [description]
         */
        $scope.groupSendMessage = function () {
            if ($scope.status.theChannelType === '订阅号' || $scope.status.theChannelType === '服务号') {
                return '未认证公众号不能群发';
            }
            if ($scope.data.selectedArray.length === 0) {
                return '请选择稿件';
            }
            if ($scope.status.theChannelType === '认证服务号') {
                return '每月最多4次';
            }
            if ($scope.status.theChannelType === '认证订阅号') {
                return '每日最多一次';
            }
        };

        /**
         * [groupSendMessageDisabled description] 群发按钮是否禁用
         * @return {[type]} [description]
         */
        $scope.groupSendMessageDisabled = function () {
            if ($scope.status.theChannelType === '订阅号' || $scope.status.theChannelType === '服务号') {
                return true;
            }
            if ($scope.data.selectedArray.length === 0) {
                return true;
            }
            if ($scope.status.theChannelType === '认证服务号') {
                return 'showTips';
            }
            if ($scope.status.theChannelType === '认证订阅号') {
                return 'showTips';
            }
        };

        /**
         * [tenantManuShare 租户间共享]
         * @return {[type]} [description]
         */
        $scope.tenantManuShare = function () {
            var params = {
                serviceid: 'mlf_wechatoper',
                methodname: 'pluralisticShare',
                dataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                ChnlDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ','),
            };
            editingCenterService.tenantShareManu(params).then(function (data) {
                if (data == 'success') {
                    requestData();
                    $scope.data.selectedArray = [];
                }
            });
        };

        /**
         * [distribution description]多元分发
         *
         * @return  {[type]}  [return description]
         */
        $scope.distribution = function () {
            $scope.status.isSearch = false;
            if (!editingCenterService.isSameDocType($scope.data.selectedArray, 'DOCTYPEID')) {
                modalDialog.alertType('', '多元分发仅支持相同类型的稿件', 'warning', 'confirm', function () {
                });
                return;
            }
            var temp = $filter('pick')($scope.data.selectedArray, $scope.examDistributionType);
            if (temp.length < 1) {
                editingCenterService.distribution($scope.data.selectedArray, '4', $scope.data.selectedArray[0].DOCTYPEID, 'weChatYiQianFaDistribute', function () {
                    $scope.data.selectedArray = [];
                    requestData();
                    // modalDialog.alertType("发稿单修改成功", "", "success", false, function() {
                    // });
                });
            } else {
                modalDialog.alertType('', '多元分发仅支持的稿件类型为图文', 'warning', 'confirm', function () {
                });
            }
        };

        /** 多元分发稿件类型  新闻:1、图集:2、链接:4、视频:8、app直播:7
         * [examDistributionType description]
         * @param  {[type]} elm [description]
         * @return {[type]}     [description]
         */
        $scope.examDistributionType = function (elm) {
            if (angular.isDefined(elm)) {
                return elm.DOCTYPEID != 1;
            }
        };

        /**
         * [docStatusFilter description] 稿件状态过滤
         * @return  {[type]}  [return description]
         */
        function docStatusFilter() {
            let docs = $filter('pick')($scope.data.selectedArray, (elm) => {
                if (elm) {
                    return $scope.status.isSendStatus[elm.massSendFalg] === '已签发' || $scope.status.isSendStatus[elm.massSendFalg] === '群发失败';
                }
            });
            let canOperate = docs.length === $scope.data.selectedArray.length;
            if (!canOperate) {
                modalDialog.alertType('请选择已签发或群发失败的稿件', '', 'warning');
            }
            return canOperate;
        }


        /*
         * [massSend description] 群发
         * @return {[type]} [description]
         */
        // $scope.massSend = function () {
        //     if ($scope.data.selectedArray.length > 8) {
        //         modalDialog.alertType('稿件不能超过8条,请重新选择', '', 'warning');
        //         return false;
        //     }
        //     if (docStatusFilter()) {
        //         wechatBtnService.massSend($scope.data.selectedArray, '', () => {
        //             requestData();
        //         });
        //     }
        // };

        /**
         * [zuBan description] 组版
         * @return {[type]}     [description]
         */
        $scope.zuBan = function () {
            if (docStatusFilter()) {
                wechatBtnService.wxLayoutEditor($scope.data.selectedArray, '', function () {
                    requestData();
                });
            }
        };
    },
]);
